import { render, staticRenderFns } from "./AssignCard.vue?vue&type=template&id=06b6f6a0&"
import script from "./AssignCard.vue?vue&type=script&lang=js&"
export * from "./AssignCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports